import React from 'react'
import BottomBar from '../../layouts/bottomBar/BottomBar'
import NavbarMobile from '../../layouts/navabrMobile/NavbarMobile'
import Navbar from '../../layouts/navbar/Navbar'
import MobileHome from '../../mobileView/home/MobileHome'

const MobHome = () => {
  return (
    <div>
        {/* <Navbar /> */}
        <NavbarMobile />
        <MobileHome />
        <BottomBar />
    </div>
  )
}

export default MobHome